import axios from "axios";

// /var host="http://localhost:8000/api/v1/da"
var host = "http://150.95.26.210/api/v1/da";

export function sendData(url, data, callback) {
  var url = host + url;
  var user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    data.token = user.user._token;
  }

  axios
    .post(url, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      alert("Connection Error");
    });
}

export function getData(url, callback) {
  var url = host + url;

  var user = JSON.parse(localStorage.getItem("user"));

  if (user) {
    if (url[url.length - 1] != "&") {
      url += "?";
    }

    url += "token=" + user.user._token;
    url += "&township_group_id=" + user.user.township_group_id;
  }

  axios
    .get(url)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      alert("Connection Error");
    });
}

export function getExcel(url) {
  var url = host + url;

  var user = JSON.parse(localStorage.getItem("user"));

  if (user) {
    if (url[url.length - 1] != "&") {
      url += "?";
    }

    url += "token=" + user.user._token;
  }

  window.location = url;
}

//export let host_storage="http://localhost:8000/storage/";
export let host_storage = "http://dashboard.tbtheunion.com/storage/";
